import snackbarObject from 'store/Constants/UI/SnackbarTypes';

const initialState = {
  display: false,
  message: '',
  variant: 'success',
};

const SnackbarReducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case snackbarObject.SNACKBAR_ERROR:
      return {
        ...state,
        variant: 'error',
        message: payload.message,
        display: true,
      };
    case snackbarObject.SNACKBAR_CLOSE:
      return {
        ...state,
        message: payload.message,
        display: false,
      };
    default: {
      return state;
    }
  }
};

export default SnackbarReducer;
